import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Button, Input, Grid, Icon, Label, Popup } from 'semantic-ui-react'
import Moment from 'react-moment'
import { VendorUsersContainer } from './styled'
import { AdminContainer } from '../../styled'
import { adminPath, vendorManagementPath } from 'routes'
import { collapseSideMenu as toggleSideMenu } from 'ducks/app'
import { getVendorUserDetail, checkVendorCode, updateVendorUserCompanies, clearUserData, setVendorUserActive, setVendorUserUnlock } from 'ducks/support'
import r from 'reactotron-react-js'
const VendorUserManagement = (props) => {
  const { history, userData } = props
  r.log({ userData })
  useEffect(() => {
    if (!props.collapseMenu) {
      props.toggleSideMenu()
    }

    return () => {
      if (props.collapseMenu && !history.location.pathname.includes('admin')) {
        props.toggleSideMenu()
      }
    }
  })

  useEffect(() => {
    return () => {
      props.clearUserData()
      setEmail('')
      setCode('')
      setCompanyIds([])
      setCompanies([{ code: '', nameTh: '' }])
    }
  }, [])

  useEffect(() => {
    if (userData.companyIds) {
      setCompanyIds(userData.companyIds)
    }

    if (userData.companies) {
      setCompanies(userData.companies)
    }
  }, [userData])

  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [companyIds, setCompanyIds] = useState([])
  const [companies, setCompanies] = useState([{ code: '', nameTh: '' }])

  const onClickDeleteCompanyButton = (companyId) => {
    if (companyIds.includes(companyId)) {
      var clone = [...companyIds]
      var index = clone.indexOf(companyId)
      if (index !== -1) {
        clone.splice(index, 1);
        setCompanyIds([...clone])
      }
    } else {
      setCompanyIds([...companyIds, companyId])
    }
  }

  const onClickAddCompany = () => {
    
    const onValidateVendorCodeSuccess = (data) => {
      const { id } = data
      setCompanyIds([...companyIds, id])
      setCompanies([...companies, { ...data }])
    }

    var company = companies.find(x => x.code === code)
    if (company !== null && company !== undefined) {
      if (companyIds.includes(company.id)) {

      } else {
        setCompanyIds([...companyIds, company.id])
      }
    } else {
      props.checkVendorCode(code, (data) => { onValidateVendorCodeSuccess(data) })
    }
  }

  const disableSaveButton = () => {
    let cloneA = userData.companyIds ? [...userData.companyIds] : []
    let cloneB = [...companyIds]

    cloneA.sort()
    cloneB.sort()

    return JSON.stringify(cloneA) === JSON.stringify(cloneB)
  }

  return (
    <AdminContainer>
      <div className='adminHeader'>
        <div className='headerTitle'>Admin Users</div>
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'Admin', content: 'Admin', link: true, onClick: () => history.push(adminPath) },
              { key: 'VendorManagement', content: 'Vendor Management', link: true, onClick: () => history.push(vendorManagementPath) },
              { key: 'UserManagement', content: 'User Management', active: true }
            ]
          }
        />
      </div>
      <VendorUsersContainer>
        <div className='inputEmailRow'>
          <Input value={email} placeholder='Input email.' onChange={(e, data) => { setEmail(data.value) }} />
          <Button
            type='button'
            content='Load user data'
            color='blue'
            style={{ marginLeft: '5px' }}
            onClick={() => { props.getVendorUserDetail(email) }}
          />
        </div>
        <div className='userDetailRow'>
          <Grid celled>
            <Grid.Row columns={6}>
              <Grid.Column width={2} style={{ fontWeight: 'bold' }}>Email</Grid.Column>
              <Grid.Column width={3}>{userData.email || ''}</Grid.Column>
              <Grid.Column width={2} style={{ fontWeight: 'bold' }}>Last Active</Grid.Column>
              <Grid.Column width={2}>{userData.lastActiveDate ? <Moment format='DD MMM YYYY HH:mm:ss'>{userData.lastActiveDate}</Moment> : ''}</Grid.Column>
              <Grid.Column width={2} style={{ fontWeight: 'bold' }}>Account Status</Grid.Column>
              <Grid.Column width={2} style={{ fontWeight: 'bold' }}>
                {userData.isLocked == undefined?null:
                <React.Fragment>
                  <Label color={`${userData.isLocked?'red':'green'}`}>{userData.isLocked?'Locked':'Normal'}</Label>
                  {userData.isLocked?
                  <Popup 
                    content='Unlock Account'
                    trigger={
                      <Button icon circular style={{ fontSize: '0.6rem' }} color='green' onClick={() => { props.setVendorUserUnlock(userData.id) }} >
                        <Icon name='sync alternate' />
                      </Button>
                    } 
                  />:null}
                </React.Fragment>}
              </Grid.Column>
              <Grid.Column width={1} style={{ fontWeight: 'bold' }}>Status</Grid.Column>
              <Grid.Column width={2} style={{ display: 'flex', padding: '0px 1rem', alignItems: 'center', justifyContent: 'space-between' }}>
                {userData.disable !== undefined ? 
                  userData.disable ? 
                    <React.Fragment>
                      <Label color='red'>Disable</Label>
                      <Popup 
                        content='Set Active User'
                        trigger={
                          <Button icon circular style={{ fontSize: '0.6rem' }} color='green' onClick={() => { props.setVendorUserActive(userData.id, true) }} >
                            <Icon name='sync alternate' />
                          </Button>
                        } 
                      />
                    </React.Fragment> : 
                    <React.Fragment>
                      <Label color='green'>Active</Label>
                      <Popup 
                        content='Set Disable User'
                        trigger={
                          <Button icon circular style={{ fontSize: '0.6rem' }} color='red' onClick={() => { props.setVendorUserActive(userData.id, false) }} >
                            <Icon name='sync alternate' />
                          </Button>
                        } 
                      />
                    </React.Fragment> : ''}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={4}>
              <Grid.Column width={2} style={{ fontWeight: 'bold' }}>Firstname</Grid.Column>
              <Grid.Column width={6}>{userData.firstname || ''}</Grid.Column>
              <Grid.Column width={2} style={{ fontWeight: 'bold' }}>Lastname</Grid.Column>
              <Grid.Column width={6}>{userData.lastname || ''}</Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column 
                width={10} 
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  fontWeight: 'bold',
                  padding: '6px 1rem',
                }}
              >
                Companies
                <Button 
                  content='Save company data'
                  color='blue'
                  disabled={disableSaveButton()}
                  onClick={() => { 
                    props.updateVendorUserCompanies({ id: userData.id, companyIds }, () => { 
                      setEmail('')
                      setCode('')
                      setCompanyIds([])
                      setCompanies([{ code: '', nameTh: '' }])
                    }) 
                  }}
                />
              </Grid.Column>
              <Grid.Column width={6} style={{ fontWeight: 'bold', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '0px' }}>
                <Input value={code} placeholder='Input vendor code.' onChange={(e, data) => { setCode(data.value) }} />
                <Button
                  type='button'
                  content='Add company'
                  color='blue'
                  disabled={code === ''}
                  style={{ marginLeft: '5px' }}
                  onClick={() => { onClickAddCompany() }}
                />
              </Grid.Column>
            </Grid.Row>
            {
              companies.map((c) => 
                <Grid.Row className={companyIds.includes(c.id) ? '' : 'disabled'}>
                  <Grid.Column width={2}>{c.code}</Grid.Column>
                  <Grid.Column width={13}>{c.nameTh}</Grid.Column>
                  <Grid.Column width={1} style={{ display: 'flex', padding: '0px', justifyContent: 'center', alignItems: 'center' }}>
                    {
                      c.id ? 
                        <Button 
                          icon 
                          color={companyIds.includes(c.id) ? 'red' : 'green'} 
                          style={{ fontSize: '0.6rem' }} 
                          onClick={() => { onClickDeleteCompanyButton(c.id) }}
                        >
                          <Icon name={companyIds.includes(c.id) ? 'trash' : 'refresh'} />
                        </Button> : null
                    }
                  </Grid.Column>
                </Grid.Row>
              )
            }
          </Grid>
        </div>
      </VendorUsersContainer>
    </AdminContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    collapseMenu: state.app.collapseSideMenu,
    userData: state.support.userData.data
  })
}

const mapDispatchToProps = {
  toggleSideMenu,
  getVendorUserDetail,
  checkVendorCode,
  updateVendorUserCompanies,
  clearUserData,
  setVendorUserActive,
  setVendorUserUnlock
}

export default connect(mapStateToProps, mapDispatchToProps)(VendorUserManagement)